import { useTranslation } from "react-i18next";

function FilesWithErrors({ files }) {
  const { t } = useTranslation("OCR");
  return (
    <div className="text-red mt-3 d-block small">
      {t("failed_files")}
      <ul>
        {files.map((file, idx) => (
          <li key={idx}>
            {file.original_name} - {file.message}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default FilesWithErrors;
